import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=84523f24&"
import script from "./chart.vue?vue&type=script&lang=js&"
export * from "./chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports